<div class="container">
  <app-generic-notification
  [titleNotification]="'Despachar Recursos para'"
  [showCost]="true"
  [packOffButton]="true"
  [commentButton]="true"
  (responseStorer)="response($event)"
  (addComment)="addComment($event)">
  </app-generic-notification> 
 </div>